<template>
    <div class="content container-fluid">
        <div class="page-header">
            <div class="row align-items-end">
                <div class="col-sm mb-2 mb-sm-0">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-no-gutter">
                            <li class="breadcrumb-item"><router-link class="breadcrumb-link" to="/">Kokpit</router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">Ustawienia</li>
                        </ol>
                    </nav>
                    <h1 class="page-header-title">Ustawienia</h1>
                </div>
            </div>
        </div>

        <div class="card shadow-sm border-0">
            <div class="card-header">
                <h4 class="card-header-title">SMS</h4>
            </div>
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h5 class="mb-1">Tryb testowy</h5>
                        <p class="text-muted mb-0">
                            SMS nie trafia do bramki SMSAPI. Wiadomość jest zapisana w liście wysłanych SMS
                            i przekazana na serwer testowy
                            <a href="https://test.magico.co.pl/sms-api-test" target="_blank" rel="noopener">test.magico.co.pl/sms-api-test</a>.
                        </p>
                    </div>
                    <div class="form-check form-switch ms-3">
                        <input
                            id="smsTestMode"
                            class="form-check-input"
                            type="checkbox"
                            v-model="smsTestMode"
                            :disabled="saving"
                            @change="save"
                        />
                        <label class="form-check-label" for="smsTestMode">
                            {{ smsTestMode ? 'Włączony' : 'Wyłączony' }}
                        </label>
                    </div>
                </div>

                <div v-if="message" class="alert alert-success mt-3 py-2">{{ message }}</div>
                <div v-if="error" class="alert alert-danger mt-3 py-2">{{ error }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import panelApi from '../api/panel-axios.js';
import appConfig from '../config.js';

export default {
    name: 'Settings',
    data() {
        return {
            smsTestMode: false,
            saving: false,
            message: '',
            error: '',
        };
    },
    methods: {
        load() {
            panelApi.get(appConfig.panelApiPrefix + '/settings').then(response => {
                const options = response.data.options || {};
                this.smsTestMode = options.sms_test_mode === true;
                this.$store.commit('app/setOptions', options);
            }).catch(err => {
                this.error = 'Nie udało się pobrać ustawień.';
                console.error(err);
            });
        },
        save() {
            this.saving = true;
            this.message = '';
            this.error = '';

            panelApi.put(appConfig.panelApiPrefix + '/settings', {
                sms_test_mode: this.smsTestMode,
            }).then(response => {
                const options = response.data.options || {};
                this.$store.commit('app/setOptions', options);
                this.message = 'Ustawienia zapisane.';
            }).catch(err => {
                this.error = 'Nie udało się zapisać ustawień.';
                console.error(err);
            }).finally(() => {
                this.saving = false;
            });
        },
    },
    mounted() {
        const options = this.$store.getters['app/options'];
        if (options && options.sms_test_mode !== undefined) {
            this.smsTestMode = options.sms_test_mode === true;
        }
        this.load();
    },
};
</script>
